import {ClockI} from '../Clock';
import {HarvestYear} from '../models/interfaces';

// NOTE: this will not always return the harvest year! Please consider using *inferHarvestYear*.
export function getCurYear(clock: ClockI) {
  return String(new Date(clock.now()).getUTCFullYear()) as HarvestYear;
}
